import first from 'lodash/first';
import isArray from 'lodash/isArray';
import isNull from 'lodash/isNull';
import isPlainObject from 'lodash/isPlainObject';
import isString from 'lodash/isString';
import isUndefined from 'lodash/isUndefined';
import map from 'lodash/map';
import merge from 'lodash/merge';
import mergeWith from 'lodash/mergeWith';
import reduce from 'lodash/reduce';
import tail from 'lodash/tail';
import toArray from 'lodash/toArray';
const messages = {
  invalid_src: 'Invalid source object.'
};
function scalarOrArray(method) {
  return function wrappedScalarOrArray(...args) {
    const extra = tail(args);
    const arg = first(args);
    if (isArray(arg)) {
      return map(arg, _arg => method.apply(this, [_arg].concat(extra)));
    }
    return method.apply(this, args);
  };
}
function keyValueOrObject(method) {
  return function wrappedKeyValueOrObject(key) {
    let extra;
    if (!isString(key)) {
      extra = tail(arguments, 1);
      return map(key, (_value, _key) => method.apply(this, [_key, _value].concat(extra)));
    }
    extra = tail(arguments, 2);
    return method.apply(this, arguments);
  };
}
const getProperty = scalarOrArray((key, from, alt) => {
  const defaultValue = isUndefined(alt) ? null : alt;
  const keys = key.split('.');
  const result = reduce(keys, (accumulator, property) => {
    if (accumulator && property in accumulator) {
      return accumulator[property];
    }
    return null;
  }, from);
  return isNull(result) || isUndefined(result) ? defaultValue : result;
});
const setProperty = keyValueOrObject((key, value, to) => {
  const keys = key.split('.');
  const prop = keys.pop();
  const result = reduce(keys, (accumulator, property) => {
    if (!(accumulator instanceof Object)) {
      throw new Error(messages.invalid_src);
    }
    if (property in accumulator && isPlainObject(accumulator[property])) {
      return accumulator[property];
    }
    accumulator[property] = {};
    return accumulator[property];
  }, to);
  if (prop) {
    result[prop] = value;
  }
});
function customMerge(oldVal, newVal) {
  if (isArray(newVal) && isArray(oldVal)) {
    return oldVal.concat(newVal);
  }
  if (isPlainObject(newVal) && isPlainObject(oldVal)) {
    return merge(oldVal, newVal, customMerge);
  }
  return newVal;
}
class Config {
  constructor() {
    this.state = {};
  }
  get(path, defaultValue) {
    if (!path || path === '') {
      return this.state;
    }
    return getProperty(path, this.state, defaultValue);
  }
  set() {
    let args = toArray(arguments);
    args = args.concat([this.state]);
    setProperty(...args);
    return this;
  }
  merge() {
    this.state = mergeWith({}, this.state, ...arguments, customMerge);
    return this;
  }
  serialize() {
    return JSON.stringify(this.state);
  }
  freeze() {
    ['set', 'merge'].forEach(prop => {
      this[prop] = () => {
        throw new Error(`Configuration is freezed, you cannot call ${prop} anymore`);
      };
    });
  }
}
Config.deserialize = function deserialize(state) {
  const config = new Config();
  return config.merge(JSON.parse(state));
};
export default Config;